<template>
    <div name="20250219" class="contents">
        <h1>개인정보 수집 및 이용 동의</h1>
        <h2>[비의료기관] 개인정보의 수집·이용 동의서</h2>

솔닥 주식회사는 진료(비대면/대면 진료)  서비스 제공을 위하여 아래와 같이 시설기관의 개인정보를 수집ᆞ이용하고자 합니다.
내용을 자세히 읽으신 후 동의 여부를 결정하여 주세요.<br>

<h3>개인정보 수집ᆞ이용 </h3>
<table>
    <thead>
      <tr>
        <th>구분</th>
        <th>처리항목</th>
        <th>세부내용</th>
        <th>보유 및 이용 기간</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td rowspan="2">회원 가입 및 관리</td>
        <td>시설 관리자</td>
        <td>아이디, 비밀번호, 근무처 정보(기관명, 주소, 연락처)</td>
        <td rowspan="8">서비스 회원 탈퇴 및 이용계약 종료 시<br>(단, 관련법령에 따라 별도 보관되는 정보는 예외)</td>
      </tr>
      <tr>
        <td>시설 소속 "환자"</td>
        <td>이름, 생년월일, 성별</td>
      </tr>
      <tr>
        <td rowspan="4">원격진료 서비스 제공<br>(진료 예약, 결제, 약 배달)</td>
        <td>원격의료 예약, 알림</td>
        <td>연락처(휴대전화번호, 전화번호), 초·재진 여부, 진료시간(원격의료 가능한 날짜·시간), 진료과목</td>
      </tr>
      <tr>
        <td>진료를 위한 기본정보</td>
        <td>신장, 체중, 혈액형, 기존 복약 정보</td>
      </tr>
      <tr>
        <td>진료를 위한 사전 문진 정보</td>
        <td>활력징후(혈압, 맥박, 호흡, 체온, 혈당), 혈액검사 결과</td>
      </tr>
      <tr>
        <td>결제 카드 등록</td>
        <td>카드사, 카드번호, 카드비밀번호 앞 2자리, 유효기간</td>
      </tr>
      <tr>
        <td rowspan="1">기타 서비스</td>
        <td>기타 서비스 이용을 위해 회원이 직접 입력하는 항목</td>
        <td>처방전 수령 및 전송, 약배달 협조 확인, 복약지도 등 기타 서비스 이용 시 회원이 직접 입력하는 항목(전자처방문서, 진료비 영수증, 진료비 세부내역서 등)</td>
      </tr>
    </tbody>
  </table>
  <br>

※ 위의 개인정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 진료(비대면/대면 진료) 서비스 이용에 제한을 받을 수 있습니다.



    </div>
</template>

<script>
export default {
    name: '20250219'
}
</script>

<style scoped>
    .contents {
        padding: 20px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;
    }
    th, td {
      border: 1px solid #000;
      padding: 8px;
      vertical-align: top;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
      text-align: center;
    }
    td {
      background-color: #ffffff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/contents/use/center/20250219.vue